export const defaultLimitShowCount = 10
export const defaultLimitAggregationCount = 20
